export default "__VITE_ASSET__DzRxv_T$__";